<template>
    <div class="physical-home-xianshi-list-time-container">
      <div class="left">
        <p><span>{{roundTime | returnTimeHours}}:00</span> 点场 倒计时</p>
      </div>
      <div class="right">
        <nr-count-down :end="roundTime" v-if="roundTime" @onEnd="onChangeNext" />
      </div>
    </div>  
</template>

<script>
import moment from 'moment'
import CountDown from '@/components/countDown'
export default {
  props: {
    roundTime:{
      type: String,
      default: ''
    }
  },
  methods: {
    onChangeNext() {
      this.$parent.load()
    }
  },
  filters: {
    returnTimeHours(date) {
      return moment(date).hour()
    }
  },
  components: {
    [CountDown.name]: CountDown,
  },
}
</script>

<style lang="scss">
  .physical-home-xianshi-list-time-container {
    position: relative;
    top: 32px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0px auto 5px;
    padding: 18px 32px;
    width: 686px;
    height: 80px;
    background: #F9F9F9;
    border-radius: 8px;
    .left {
      p {
        font-size: 28px;
        font-weight: 400;
        line-height: 29px;
        color: #636666;
        span {
          font-size: 32px;
          font-weight: bold;
          color: #EF4B61;
        }
      }
    }
    .right {
      .nr-count-down-container {
        text-align: center;
        .date {
          font-size: 28px;
          font-weight: bold;
          color: #EF4B61;
          width: 48px;
          line-height: 48px;
          background: #E1E1E6;
          border-radius: 4px;
        }
        .colon {
          width: 28px;
          font-size: 28px;
          font-weight: 400;
          line-height: 38px;
          color: #636666;
        }
      }
    }
  }
</style>